export default __webpack_public_path__ + "static/illustration-content-title.url-22031dc439b565c84a1e990463c64de7.svg";